<template>
  <table class="table" style="padding-top: 0px;">
    <tr>
      <td style="width: 650px;">
        <table class="table" style=" width: 100%">
          <tr>
            <td style="width: 164px; height: 60px;" class="ico ico-home">
              <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
            <td>
              <h2 style="font-size:15px; text-align: center;">
                제품 불량 판정서(고객용)
              </h2>
            </td>
            <td style="width: 100px;"></td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
          <tr style="background-color: white;">
            <td height="30">서비스 접수번호</td>
            <td colspan="5">{{asRepair.asId}}-{{idx + 1}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">모델명</td>
            <td colspan="2">{{asRepair.modelNm}}</td>
            <td>접수일시</td>
            <td colspan="2">{{asRepair.callDt}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">제조번호</td>
            <td colspan="2">{{asRepair.serialNo}}</td>
            <td>비고</td>
<!--            <td colspan="2">{{asRepair.etc}}</td>-->
            <td colspan="2"></td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">접수내용</td>
            <td colspan="5">{{asRepair.asFailureCauseCatNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">불량구분</td>
            <td colspan="1">고장부위</td>
            <td colspan="1">{{asRepair.asFailureCauseCatFullNm}}</td>
            <td>고장증상</td>
            <td colspan="2">{{asRepair.asDescription}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="50">판정소견</td>
            <td colspan="5"></td>
<!--            <td colspan="5">{{asRepair.opinion}}</td>-->
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>※ 유의사항※</td>
    </tr>
    <tr>
      <td> -  교환 및 환불을 원하시면 판정서 원본을 구입한 대리점에 제출 해야합니다.</td>
    </tr>
    <tr>
      <td> -  판정서가 원본이 아닐 경우(복사본, 팩스 등) 교환 처리가 불가할수 있습니다.</td>
    </tr>
    <tr>
      <td> -  판정서 분실시에는 발급한 센터를 통해 재발급을 받을수 있습니다.</td>
    </tr>
    <tr>
      <td> -  1달 이내에 중요 부위 불량일 경우 불량 판정서를 작성합니다. </td>
    </tr>
    <tr>
      <td>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" height="100%">

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="30%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">불량판정일 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0" class="font-big">
                      <tr>
                        <td height="5">
<!--                          &nbsp;<br />-->
                          {{$moment().format('YYYY-MM-DD')}}
<!--                          <br />&nbsp;-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="100%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">판 정 센 터 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0"  class="font-big">
                      <tr>
                        <td height="5">
<!--                          &nbsp;<br />-->
                          {{asAgentNm}}
<!--                          <br />&nbsp;-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="40%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">담 당 기 사 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0" class="font-big">
                      <tr>
                        <td height="10">
                          &nbsp;<br />
                          {{$store.state.loginInfo.userName}}   (인)
                          <br />&nbsp;
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>


<!--          <tr>-->
<!--            <td width="30%" class="font-big" height="10">불량판정일 :</td><td>{{$moment().format('YYYY-MM-DD')}}</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td width="30%" class="font-big" height="10">판 정 센 터 :</td><td>{{$store.state.loginInfo.userName}}</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td width="30%" class="font-big" height="10">담 당 기 사 :</td><td>{{$store.state.loginInfo.userName}}   (인)</td>-->
<!--          </tr>-->
        </table>
      </td>
    </tr>
<!--    <tr>-->
<!--      <td style="height: 60px;" height="45">&nbsp;</td>-->
<!--    </tr>-->
    <tr height="50">
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td>
        <hr style="border: dashed 2px #666666;"/>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
    </tr>

    <tr>
      <td style="width: 650px;">
        <table class="table" style=" width: 100%">
          <tr>
            <td style="width: 164px; height: 60px;" class="ico ico-home">
              <img src="@/../public/img/ot_logo3.jpg" width="150" height="59"></td>
            <td>
              <h2 style="font-size:15px; text-align: center;">
                제품 불량 판정서(센터보관용)
              </h2>
            </td>
            <td style="width: 100px;"></td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <table width="650" border="1" cellpadding="0" cellspacing="0" bordercolor="#333333" bgcolor="#333333" class="font-big" style="table-layout:fixed">
          <tr style="background-color: white;">
            <td height="30">서비스 접수번호</td>
            <td colspan="5">{{asRepair.asId}}-{{idx + 1}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">모델명</td>
            <td colspan="2">{{asRepair.modelNm}}</td>
            <td>접수일시</td>
            <td colspan="2">{{asRepair.callDt}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">제조번호</td>
            <td colspan="2">{{asRepair.serialNo}}</td>
            <td>비고</td>
            <!--            <td colspan="2">{{asRepair.etc}}</td>-->
            <td colspan="2"></td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">접수내용</td>
            <td colspan="5">{{asRepair.asFailureCauseCatNm}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="30">불량구분</td>
            <td colspan="1">고장부위</td>
            <td colspan="1">{{asRepair.asFailureCauseCatFullNm}}</td>
            <td>고장증상</td>
            <td colspan="2">{{asRepair.asDescription}}</td>
          </tr>
          <tr style="background-color: white;">
            <td height="50">판정소견</td>
            <td colspan="5"></td>
            <!--            <td colspan="5">{{asRepair.opinion}}</td>-->
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td>※ 유의사항※</td>
    </tr>
    <tr>
      <td> -  교환 및 환불을 원하시면 판정서 원본을 구입한 대리점에 제출 해야합니다.</td>
    </tr>
    <tr>
      <td> -  판정서가 원본이 아닐 경우(복사본, 팩스 등) 교환 처리가 불가할수 있습니다.</td>
    </tr>
    <tr>
      <td> -  판정서 분실시에는 발급한 센터를 통해 재발급을 받을수 있습니다.</td>
    </tr>
    <tr>
      <td> -  1달 이내에 중요 부위 불량일 경우 불량 판정서를 작성합니다. </td>
    </tr>
    <tr>
      <td>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" height="100%">

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="30%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">불량판정일 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0"  class="font-big">
                      <tr>
                        <td height="5">
                          <!--                          &nbsp;<br />-->
                          {{$moment().format('YYYY-MM-DD')}}
                          <!--                          <br />&nbsp;-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="100%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">판 정 센 터 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0"  class="font-big">
                      <tr>
                        <td height="5">
                          <!--                          &nbsp;<br />-->
                          {{asAgentNm}}
                          <!--                          <br />&nbsp;-->
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <table width="100%" border="0" cellspacing="0" cellpadding="0" height="40%">
                <tr>
                  <td width="37%">&nbsp;</td>
                  <td width="33%" class="font-big">담 당 기 사 : </td>
                  <td width="30%">
                    <table width="100%" border="1" cellpadding="0" cellspacing="0"  class="font-big">
                      <tr>
                        <td height="10">
                          &nbsp;<br />
                          {{$store.state.loginInfo.userName}}   (인)
                          <br />&nbsp;
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>


          <!--          <tr>-->
          <!--            <td width="30%" class="font-big" height="10">불량판정일 :</td><td>{{$moment().format('YYYY-MM-DD')}}</td>-->
          <!--          </tr>-->
          <!--          <tr>-->
          <!--            <td width="30%" class="font-big" height="10">판 정 센 터 :</td><td>{{$store.state.loginInfo.userName}}</td>-->
          <!--          </tr>-->
          <!--          <tr>-->
          <!--            <td width="30%" class="font-big" height="10">담 당 기 사 :</td><td>{{$store.state.loginInfo.userName}}   (인)</td>-->
          <!--          </tr>-->
        </table>
      </td>
    </tr>
    <tr height="75"></tr>
  </table>
</template>
<script>
export default {
  name : 'RepairScreen',
  props: {
    asRepair: {
      Type: Object,
      default: {
        asId: ''
      }
    },
    idx: {
      Type: Number,
    },
    asItem: {
      Type: Array,
    },
    asAgentNm: {
      Type : String,
    }

  },
  data() {
    return {
    };
  },
}
</script>
